import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {IPublicTrainingCourse} from "../../models/TrainingCourse";

interface ClassesState {
    classes: IPublicTrainingCourse[],
    visibleClasses: IPublicTrainingCourse[],
    isClassesLoading: boolean,
}

const initialState: ClassesState = {
    classes: [],
    visibleClasses: [],
    isClassesLoading: true,
}

export const classesSlice = createSlice({
    name: "classes",
    initialState,
    reducers: {
        setClasses: (state, action: PayloadAction<IPublicTrainingCourse[]>) => {
            state.isClassesLoading = false;
            state.classes = action.payload;
            state.visibleClasses = action.payload.filter(el => el.visibleForWebsite);
        }
    }
})

export const {setClasses} = classesSlice.actions;

export default classesSlice.reducer;